import React, { useEffect } from 'react';
import Layout from '../components/Layout';

export default function ThankYouPage() {

  useEffect(() => {
    // make sure the correlation ID gets removed
    // to avoid cross-session population
    sessionStorage.removeItem('correlation_id')
  }, []);

  return (
    <Layout
      title="Thank you!"
      description="Your payment information was successfully sent. You will receive a confirmation email shortly."
    >
      {/* Hier z.B. Bestellzusammenfassung, Links, etc. einfügen */}
    </Layout>
  );
}
